(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3006],{

/***/ 5454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/payment-guideline/index.js
var payment_guideline = __webpack_require__(78152);
;// CONCATENATED MODULE: ./pages/offshore/payment-guideline/data.json
var data_namespaceObject = JSON.parse('{"country":"offshore","banner_image":"payment-guideline.png","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Payment Guideline ","uri":"/payment-guideline"}],"dataInternationalTransfer":{"note":"Please Note: Invoice number must be provided together with payment. If you are paying for multiple invoices, please provide all invoice numbers in full and separated by ” / ” with a space before and after.","content":"<p class=\'mb-4\'>Multi-currencies Account Number: 802378041831</p><p class=\'mb-4\'>Account Name: BBCIncorp Limited</p><p class=\'mb-4\'>Bank Name: OCBC WING HANG BANK LIMITED</p><p class=\'mb-4\'>Address: 161 Queen&rsquo;s Road Central, Hong Kong</p><p class=\'mb-4\'>Swift Code: WIHBHKHH</p><p class=\'mb-4\'>Bank Code: 035</p><p class=\'mb-4\'>Branch Code: 802</p>"},"dataLocalTransfer":{"left_content":"Please Note: Invoice number must be provided together with payment. If you are paying for multiple invoices, please provide all invoice numbers in full and separated by ” / ” with a space before and after.","right_content":[{"name":"Hongkong (HKD)","icon":"hk.svg","content":{"title":"Bank in Hong Kong","content":"<p>Account Number: 802378041831</p><p>Account Name: BBCIncorp Limited</p><p>Bank Name: OCBC WING HANG BANK LIMITED</p><p>Address: 161 Queen&rsquo;s Road Central, Hong Kong</p><p>Swift Code: WIHBHKHH</p><div class=\'flex justify-between\'><span>Bank Code: 035</span> <span>Branch Code: 802</span></div>"}},{"name":"US (USD)","icon":"um.svg","content":{"title":"ACH/ Fedwire Transfer in United State (USD)","content":"<ul><li>Account Name: BBCIncorp Limited</li><li>Account number: 8452540302</li><li>ACH routing number: 026073150</li><li>Fedwire routing number: 026073008</li><li>SWIFT code: CMFGUS33</li><li>Account type: Checking</li><li>Bank name: Community Federal Savings Bank</li><li>Bank address: 89-16 Jamaica Ave, Woodhaven, NY 11421</li></ul>"}},{"name":"UK (GBP)","icon":"gb.svg","content":{"title":"Faster/ BACS/ CHAPS Transfer in United Kingdom (GBP)","content":"<ul><li>Account name: BBCIncorp Limited</li><li>Account number: 01660186</li><li>Sort code: 040301</li><li>IBAN: GB29LHVB04030101660186</li><li>Bank name: AS LHV PANK</li><li>Bank address: 1 Old Street Yard, London EC1Y 8AF</li></ul>"}},{"name":"EUROPE (EURO)","content":{"title":"SEPA Transfer in Europe","content":"<ul><li>Account name: BBCIncorp Limited</li><li>IBAN: EE917777000125450911</li><li>SWIFT code: LHVBEE22</li><li>Account location: Estonia (Europe)</li><li>Bank name: AS LHV PANK</li><li>Bank address: Tartu mnt 2, Tallinn 10145</li></ul>"}}]}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/payment-guideline/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(payment_guideline/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 61837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/payment-guideline",
      function () {
        return __webpack_require__(5454);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,4090,9738,7447,4982,9774,2888,179], function() { return __webpack_exec__(61837); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);